<div mat-dialog-title class="promo-header">
  <div class="promo-header-row">
    <h2 class="promo-header-title">Introducing Covercy AI <span class="new-badge">NEW!</span></h2>
    <mat-icon class="close-icon" mat-dialog-close cdkFocusInitial>close</mat-icon>
  </div>
</div>
<img src="assets/images/promo/covercy-ai.png" alt="Capital Commitment" class="promo-image" />
<div class="promo-description">
  <h3>Meet Covercy AI: Your Investment Management Assistant</h3>
  <p>
    <b>With Covercy AI</b>, you can now quickly and effortlessly create professional, coherent texts for any purpose.
    <u>From quarterly reports and opportunity pages to investor emails and marketing materials.</u>
    Crafting clear, impactful communication has never been easier.
  </p>
  <p>
    <b>And this is just the beginning.</b> As Covercy AI evolves, you’ll be able to ask any question about your
    portfolio and instantly gain valuable insights without needing to search for information yourself.
    Simply ask, and the answers are at your fingertips.
  </p>
  <p>
    Our partnership with ChatGPT brings you unparalleled value while keeping your <b>data 100% secure</b>.
    Your data never leaves our servers hosted by Microsoft Azure, ensuring it remains private and protected,
    giving you peace of mind while you benefit from AI-driven efficiency.
  </p>
</div>
<mat-dialog-actions class="flex flex-row gap-1 promo-actions" align="end">
  <terra-buttons type="secondary" label="Got it" (onClick)="action()"></terra-buttons>
</mat-dialog-actions>
